<template>
  <div class="specs" :class="{ disabled }">
    <RadioGroup
      v-if="specsVariable"
      v-model="specTypeBind"
      class="specs-switch"
      type="button"
      size="small"
    >
      <Radio label="单规格"></Radio>
      <Radio label="多规格"></Radio>
    </RadioGroup>
    <SingleSpecs
      v-if="specType === 0"
      v-bind="$props"
      @input="onInput"
    ></SingleSpecs>
    <MultipleSpecs
      v-else
      v-bind="$props"
      @change="onMultipleSpecsChange"
    ></MultipleSpecs>
  </div>
</template>
<style lang="stylus" scoped>
.specs
  position relative

  &.disabled::before
    content ''
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background rgba(#ddd, 0.5)
    z-index 5
    cursor not-allowed

  .specs-switch
    position absolute
    top -30px
    right 0
</style>
<script>
import SingleSpecs from './SingleSpecs'
import MultipleSpecs from './MultipleSpecs'
export default {
  components: {
    SingleSpecs,
    MultipleSpecs,
  },
  props: [
    'value',
    'options',
    'max',
    'specType',
    'specsVariable',
    'skus',
    'extraSpecs',
    'disabled'
  ],
  data() {
    return {
      specTypeBind: '单规格',
    }
  },
  watch: {
    specTypeBind(newValue, oldValue) {
      this.$Modal.confirm({
        title: '注意',
        content: '切换规格类型将清空当前规格配置！',
        okText: '知道了',
        onOk: () => {
          if (newValue === '单规格') {
            this.$emit('input', [])
            this.$emit('update:specType', 0)
          } else {
            this.$emit('update:skus', [])
            this.$emit('update:extraSpecs', [])
            this.$emit('update:specType', 1)
          }
        },
        onCancel: () => {
          this.specTypeBind = oldValue
          this.$emit('update:specType', oldValue === '单规格' ? 0 : 1)
        },
      })
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
   // onInputExtra(value) {
      //this.$emit('inputExtra', value)
    //},
    onMultipleSpecsChange(payload) {
      console.log('onMultipleSpecsChange', payload)
      if (payload.prop === 'value') {
        this.$emit('input', payload.value)
        
      } else {
        this.$emit(`update:${payload.prop}`, payload.value)
      }
    },
  },
}
</script>
